var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoveIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 15A7 7 0 108 1a7 7 0 000 14zm3-10a.6.6 0 00-.848 0L8 7.152 5.85 5A.6.6 0 105 5.85L7.152 8 5 10.152a.6.6 0 10.849.848L8 8.85 10.152 11a.6.6 0 00.849-.848L8.849 8 11 5.85A.6.6 0 0011 5z",
    fill: "#C0C8D6"
  })));
}
export default __webpack_public_path__ + "static/remove-icon.2a9fbd1f.svg";
export { SvgRemoveIcon as ReactComponent };